// extracted by mini-css-extract-plugin
export default {"sliderContainer":"slider_sliderContainer__N0Mey","carousel":"slider_carousel__B5Qew","navButtonPrev":"slider_navButtonPrev__vx7p9","navButtonNext":"slider_navButtonNext__-FOP5"};